<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div
        v-if="active"
        class="block has-red-background is-flex"
      >
        <div class="status-icon is-flex">
          <font-awesome-icon icon="info" />
        </div>
        <div class="inner-block">
          <h1 class="title">
            {{ $t("fehlerView.label.reservationFailed") }}
          </h1>
          <h2 class="subtitle">
            {{ $t("fehlerView.label.reservationFailedHint") }}
          </h2>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
    export default {
        name: 'Start',
        props: {
            msg: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                active: false
            }
        },
        mounted() {
            this.active = true
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .block {
        &.has-green-background,
        &.has-red-background {
            h1, h2, p {
                color: rgba(255, 255, 255, 1);
            }

            h2 {
                margin-bottom: 0;
            }

            padding: 1rem 1.2rem 1rem 1.2rem;
            justify-content: flex-start;
        }

        &.has-green-background {
            background-color: rgb(0, 180, 80);
        }

        &.has-red-background {
            background-color: rgb(200, 0, 50);
        }
    }

    .status-icon {
        width: 3rem;
        height: 3rem;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        margin-right: 1.2rem;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 1rem;
    }

    @media all and (min-width: 680px) and (max-width: 800px) {

    }

    @media (max-width: 680px) {
        .status-icon {
            margin-right: 1rem;
        }
    }

    @media (max-width: 325px) {
        .block {
            &.has-green-background,
            &.has-red-background {

                h1 {
                    font-size: .8rem;
                }

                h2 {
                    font-size: 0.5rem;
                }

                padding: 1rem 1.2rem 1rem 1.2rem;
            }
        }
    }
</style>
